import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/services";
import { MaskLines, Overline, Reveal } from "../site/Motion";
import { EASE } from "../../lib/api";

const SPANS = [
  "md:col-span-2 lg:col-span-7 lg:row-span-2",
  "lg:col-span-5",
  "lg:col-span-5",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-4",
  "lg:col-span-6",
  "md:col-span-2 lg:col-span-6",
];

const Tile = ({ s, i }) => (
  <motion.div className={SPANS[i]} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }}>
    <Link to={`/services/${s.slug}`} data-testid={`service-tile-${s.slug}`}
      className="group clip-notch-sm relative flex h-full min-h-[300px] flex-col justify-between overflow-hidden bg-[var(--ink-2)] p-6 md:p-7 lg:min-h-0">
      <img src={s.img} alt={s.title} loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-45 grayscale transition-[transform,opacity,filter] duration-1000 ease-out group-hover:scale-105 group-hover:opacity-70 group-hover:grayscale-0" />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--ink)] via-[rgba(14,15,12,0.55)] to-[rgba(14,15,12,0.15)]" />
      <div className="relative flex items-start justify-between">
        <span className="font-mono text-sm text-[var(--signal)]">{s.code} / 08</span>
        <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/25 transition-[background-color,border-color,transform] duration-500 group-hover:rotate-45 group-hover:border-[var(--signal)] group-hover:bg-[var(--signal)] group-hover:text-[var(--ink)]">
          <ArrowUpRight className="h-5 w-5" />
        </span>
      </div>
      <div className="relative">
        <h3 className={`font-display font-extrabold uppercase leading-[0.9] ${i === 0 ? "text-5xl md:text-7xl" : "text-4xl md:text-5xl"}`}>{s.title}</h3>
        <p className="mt-3 max-w-md text-sm text-[var(--bone-2)] md:text-base">{s.tagline}</p>
      </div>
    </Link>
  </motion.div>
);

export const ServicesBento = () => (
  <section id="services" className="relative bg-[var(--ink)] py-24 md:py-36" data-testid="services-section">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <div className="mb-14 grid gap-8 md:mb-20 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Overline>What we run</Overline>
          <MaskLines lines={["Eight services.", "One point of contact."]}
            className="mt-6 font-display text-5xl font-black uppercase leading-[0.9] md:text-7xl lg:text-8xl"
            lineClass={(i) => (i === 1 ? "text-outline" : "")} />
        </div>
        <Reveal className="lg:col-span-4 lg:col-start-9">
          <p className="text-base text-[var(--bone-2)] md:text-lg">
            Take one service or combine several. Manpower, back-office and logistics are planned together so nothing falls between vendors.
          </p>
        </Reveal>
      </div>
      <div className="grid auto-rows-[300px] grid-cols-1 gap-4 md:grid-cols-2 md:gap-5 lg:auto-rows-[250px] lg:grid-cols-12">
        {SERVICES.map((s, i) => <Tile key={s.slug} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
